import React from "react";
import {Redirect, Switch} from "react-router-dom";
import {PrivateRouteWithLayout} from "../components";
import {Main as MainLayout} from "../layouts";

import {
    BaseliningSkills as School_Baselining_Skills,
    BaseliningCyber as School_Baselining_Cyber,
    AssessmentAdoption as School_Assessment_Adoption,
    AssessmentEfficacy as School_Assessment_Efficacy,
    EnhancementAdoption as School_Enhancement_Adoption,
    EnhancementEfficacy as School_Enhancement_Efficacy,
    Analysis as School_Analysis,
    Summary as School_Summary,
    Progress as Combined_Progress,
    SchoolProgress as Schools_Progress,
    ClassProgress as Classes_Progress,
    StudentsProgress as Students_Progress,
    Resources as School_Resources
} from "../pages/SchoolDashboard";

import {
    ReportOverviewParent as ReportOverviewParentPage,
    ReportOverviewSchool as ReportOverviewSchoolPage,
    ChildScore as ChildScorePage,
    ParentRecommendations as ParentRecommendationsPage,
    SchoolRecommendations as SchoolRecommendationsPage,
    SchoolScore as SchoolScorePage,
    Participation as ParticipationPage,
    SchoolEfficacy as SchoolEfficacyPage,
    ScoresOverview as ScoresOverviewPage
} from "../pages/SchoolDashboardR2";

import {
    Classes as EmployeeClassesPage,
    Employees as EmployeesPage,
    EmployeesPendingActivation as EmployeesPendingActivationPage,
    EmployeesPendingApprovals as EmployeesPendingApprovalsPage,
    Schools as EmployeeSchoolsPage
} from "../pages";
import {isDQInsiderORG} from "../utils/utils";
const IS_DQ_INSIDER_ORG = isDQInsiderORG();
export default [
    <Redirect
        exact
        from={`/:lc/home`}
        to={`/:lc/school/home`}
    />,

    IS_DQ_INSIDER_ORG ? (
        <Redirect
            exact
            from={`/:lc/school/home`}
            to={`/:lc/school/scores_overview`}
        />
    ) : (
        <Redirect
            exact
            from={`/:lc/school/home`}
            to={`/:lc/school/home/competencies`}
        />
    ),

    <PrivateRouteWithLayout
        component={ReportOverviewSchoolPage}
        exact
        layout={MainLayout}
        path={`/:lc/school/report_overview`}
    />,

    <PrivateRouteWithLayout
        component={SchoolRecommendationsPage}
        exact
        layout={MainLayout}
        path={`/:lc/school/recommendations`}
    />,

    <PrivateRouteWithLayout
        component={SchoolEfficacyPage}
        exact
        layout={MainLayout}
        path={`/:lc/school/efficacy/overall`}
    />,
    <PrivateRouteWithLayout
        component={SchoolEfficacyPage}
        exact
        layout={MainLayout}
        path={`/:lc/school/efficacy/breakdown`}
    />,

    <PrivateRouteWithLayout
        component={ScoresOverviewPage}
        exact
        layout={MainLayout}
        path={`/:lc/school/scores_overview`}
    />,

    <PrivateRouteWithLayout
        component={SchoolScorePage}
        exact
        layout={MainLayout}
        path={`/:lc/school/school_score/overall`}
    />,

    <PrivateRouteWithLayout
        component={SchoolScorePage}
        exact
        layout={MainLayout}
        path={`/:lc/school/school_score/by_age`}
    />,

    <PrivateRouteWithLayout
        component={SchoolScorePage}
        exact
        layout={MainLayout}
        path={`/:lc/school/school_score/by_level`}
    />,

    <PrivateRouteWithLayout
        component={SchoolScorePage}
        exact
        layout={MainLayout}
        path={`/:lc/school/school_score/by_class`}
    />,

    <PrivateRouteWithLayout
        component={ParticipationPage}
        exact
        layout={MainLayout}
        path={`/:lc/school/participation/summary`}
    />,

    <PrivateRouteWithLayout
        component={ParticipationPage}
        exact
        layout={MainLayout}
        path={`/:lc/school/participation/by_month`}
    />,

    <PrivateRouteWithLayout
        component={ParticipationPage}
        exact
        layout={MainLayout}
        path={`/:lc/school/participation/by_age`}
    />,

    <PrivateRouteWithLayout
        component={ParticipationPage}
        exact
        layout={MainLayout}
        path={`/:lc/school/participation/by_grade_level`}
    />,

    <PrivateRouteWithLayout
        component={ParticipationPage}
        exact
        layout={MainLayout}
        path={`/:lc/school/participation/by_class`}
    />,

    <PrivateRouteWithLayout
        component={School_Baselining_Skills}
        exact
        layout={MainLayout}
        path={`/:lc/school/home/competencies`}
    />,

    <PrivateRouteWithLayout
        component={School_Baselining_Cyber}
        exact
        layout={MainLayout}
        path={`/:lc/school/home/cyber`}
    />,

    <Redirect
        exact
        from={`/:lc/school/assessment`}
        to={`/:lc/school/assessment/reach`}
    />,

    <PrivateRouteWithLayout
        component={School_Assessment_Adoption}
        layout={MainLayout}
        exact
        path={`/:lc/school/assessment/reach`}
    />,

    <PrivateRouteWithLayout
        component={School_Assessment_Efficacy}
        layout={MainLayout}
        exact
        path={`/:lc/school/assessment/efficacy`}
    />,

    <Redirect
        exact
        from={`/:lc/school/enhancement`}
        to={`/:lc/school/enhancement/reach`}
    />,

    <PrivateRouteWithLayout
        component={School_Enhancement_Adoption}
        layout={MainLayout}
        exact
        path={`/:lc/school/enhancement/reach`}
    />,

    <PrivateRouteWithLayout
        component={School_Enhancement_Efficacy}
        layout={MainLayout}
        exact
        path={`/:lc/school/enhancement/efficacy`}
    />,

    <PrivateRouteWithLayout
        component={EmployeeClassesPage}
        exact
        layout={MainLayout}
        path={`/:lc/students/classes`}
    />,

    <PrivateRouteWithLayout
        component={EmployeeSchoolsPage}
        exact
        layout={MainLayout}
        path={`/:lc/students/schools`}
    />,

    <PrivateRouteWithLayout
        component={EmployeesPage}
        exact
        layout={MainLayout}
        path={`/:lc/students/list`}
    />,

    <PrivateRouteWithLayout
        component={EmployeesPendingActivationPage}
        exact
        layout={MainLayout}
        path={`/:lc/students/activation`}
    />,

    <PrivateRouteWithLayout
        component={EmployeesPendingApprovalsPage}
        exact
        layout={MainLayout}
        path={`/:lc/students/approval`}
    />,

    <PrivateRouteWithLayout
        component={School_Analysis}
        exact
        layout={MainLayout}
        path={`/:lc/analysis`}
    />,

    <PrivateRouteWithLayout
        component={School_Summary}
        exact
        layout={MainLayout}
        path={`/:lc/analysis/summary`}
    />,

    <PrivateRouteWithLayout
        component={Combined_Progress}
        exact
        layout={MainLayout}
        path={`/:lc/progress`}
    />,

    <PrivateRouteWithLayout
        component={Schools_Progress}
        exact
        layout={MainLayout}
        path={`/:lc/progress/schools`}
    />,

    <PrivateRouteWithLayout
        component={Classes_Progress}
        exact
        layout={MainLayout}
        path={`/:lc/progress/classes`}
    />,

    <PrivateRouteWithLayout
        component={Students_Progress}
        exact
        layout={MainLayout}
        path={`/:lc/progress/students`}
    />,

    <PrivateRouteWithLayout
        component={School_Resources}
        exact
        layout={MainLayout}
        path={`/:lc/resources`}
    />,

]